var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolkadot = function SvgPolkadot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#3F3F3F",
    rx: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#polkadot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.815 3.226A3.718 3.718 0 0 0 4.308 8.13a.53.53 0 0 0 .651.325c.26-.1.398-.384.315-.65a2.443 2.443 0 0 1-.144-.943 2.671 2.671 0 1 1 2.832 2.746s-.52.032-.778.063c-.096.014-.19.033-.283.057a.034.034 0 0 1-.049 0 .034.034 0 0 1 0-.042l.08-.439.488-2.195a.508.508 0 0 0-.992-.213s-1.161 5.374-1.161 5.423a.488.488 0 0 0 .36.595h.028c.26.068.527-.09.594-.35.001-.005.003-.009.003-.014v-.024c.015-.063.161-.778.161-.778.111-.54.546-.953 1.09-1.037.113-.017.583-.049.583-.049a3.7 3.7 0 0 0-.27-7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6007A",
    d: "M8.04 11.763a.617.617 0 0 0-.73.478l-.001.01a.615.615 0 0 0 .47.732h.018a.605.605 0 0 0 .73-.446c0-.003 0-.005.002-.008v-.034a.64.64 0 0 0-.489-.732Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "polkadot_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.113 3.226h7.307V13H4.113z"
  })))));
};
export default SvgPolkadot;